import React from "react";

const fileIcons = {
    "doc": "📄",  // Replace with Word document icon
    "docx": "📄",
    "xls": "📊",  // Replace with Excel document icon
    "xlsx": "📊",
    "csv": "📜",
    "pdf": "📑",
    "jpg": "🖼️",
    "png": "🖼️",
    "txt": "📃",
  };
  
  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    return fileIcons[ext] || "📁"; // Default folder icon if unknown type
  };

const AttachmentList = ({ attachments, onDelete }) => {
  return (
    <div>
        <div>Attachments</div>

    <div className="attachment-container d-flex flex-wrap">
      {attachments?.map((attachment) => (
        <div key={attachment.id} className="attachment-item text-center me-3 position-relative">
          <span className="file-icon" style={{ fontSize: "2rem" }}>
            {getFileIcon(attachment.file_name)}
          </span>
          <button 
            className="delete-btn position-absolute top-0 end-0 btn btn-sm btn-danger"
            onClick={() => onDelete(attachment.id)}
            style={{ padding: "0px 5px", fontSize: "10px", borderRadius: "50%" }}
          >
            ✖
          </button>
          <div className="file-name text-truncate mt-1" style={{ width: "70px" }}>
            {attachment.file_name.split(".")[0]}
          </div>
        </div>
      ))}
    </div>
    </div>

  );
};

export default AttachmentList;
